<template>
  <div class="dialog-frame" @click="onPlay">
    <Loader :small="true" class="loader" v-if="loading"/>
    <Background :background="getBackground" v-if="!loading" class="background"/>
    <div class="title-box" v-if="!loading">
      {{ dialogData.title }}
    </div>
    <div class="play-box" v-if="!loading">
      <font-awesome-icon icon="play-circle" class="icon"/>
    </div>
  </div>
</template>

<script>
import Loader from '../Loader'
import alert from '../Alert'
import axios from 'axios'
import Background from '../EditTree/Background'
import iframe from '@/lib/iframe'

export default {
  name: 'DialogFrame',
  props: {
    dialogId: String
  },
  data() {
    return {
      loading: true,
      dialogData: null
    }
  },
  components: {
    Loader,
    Background
  },
  methods: {
    loadData() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadMiniDialogData`,
        data: {
          dialogId: this.dialogId
        }
      }).then(result => {
        this.dialogData = result.data.dialogData;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        console.log(err);
        alert.showError(err);
      })
    },
    onPlay() {
      iframe.open(this.getLink);
    }
  },
  mounted() {
    this.loadData();
  },
  computed: {
    getBackground() {
      if(this.dialogData) {
        if(this.dialogData.background.type == 'upload') {
          let background = {}
          background.type = 'upload';
          background.data = this.dialogData.backgroundStore[0].data;
          return background;
        } else {
          return this.dialogData.background;
        }
      } else {
        return null;
      }
    },
    getLink() {
      return `${window.location.origin}/hub?exercise_id=${this.dialogId}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-frame {
  width: 25rem;
  height: 16rem;
  margin-left: 2rem;
  &:first-of-type {
    margin-left: 0rem;
  }
  position: relative;
  overflow: hidden;
  border-radius: 0.3rem;
  background-color: #3E4046;
  @media (max-width: 1300px) {
    margin-left: 0rem;
  }
  @media (max-width: 600px) {
    margin-bottom: 2rem;
    width: 90%;
    height: 90vh;
  }

  transition: 0.3s;
  &:hover {
    cursor: pointer;
    .background {
      filter: blur(2px);
    }
    .play-box {
      opacity: 1;
    }
  }
}

.background {
  transition: 0.3s;
}

.title-box {
  width: 100%;
  height: 3rem;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  padding-left: 1rem;
  background-color: #11B6A5;
  color: white;
  font-size: 1.2rem;
}

.play-box {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.3s;

  .icon {
    color: #F4F4F4;
    font-size: 5rem;
    margin-top: 1.5rem;
  }
}

.loader {
  z-index: 0;
  position: absolute;
}
</style>